/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const connectVoice = /* GraphQL */ `
  mutation ConnectVoice($input: ConnectVoiceInput) {
    connectVoice(input: $input) {
      metadata
      contact_id
    }
  }
`;
export const createFolder = /* GraphQL */ `
  mutation CreateFolder($input: CreateFolderInput!) {
    createFolder(input: $input) {
      cognito_sub
      key
    }
  }
`;
export const deleteFile = /* GraphQL */ `
  mutation DeleteFile($input: DeleteFileInput!) {
    deleteFile(input: $input) {
      cognito_sub
      file_key
      key
    }
  }
`;
export const deleteUserAccount = /* GraphQL */ `
  mutation DeleteUserAccount {
    deleteUserAccount {
      cognito_sub
      success
      message
    }
  }
`;
export const launchAgent = /* GraphQL */ `
  mutation LaunchAgent(
    $agent_name: String!
    $contact_id: String!
    $demo: Boolean
    $transfer_phone_number: String!
  ) {
    launchAgent(
      agent_name: $agent_name
      contact_id: $contact_id
      demo: $demo
      transfer_phone_number: $transfer_phone_number
    )
  }
`;
export const mergeSubject = /* GraphQL */ `
  mutation MergeSubject($input: MergeSubjectInput!) {
    mergeSubject(input: $input) {
      success
    }
  }
`;
export const uploadFile = /* GraphQL */ `
  mutation UploadFile($input: UploadFileInput!) {
    uploadFile(input: $input) {
      cognito_sub
      file_key
      upload_url
    }
  }
`;
export const uploadProtocol = /* GraphQL */ `
  mutation UploadProtocol($input: UploadProtocolInput!) {
    uploadProtocol(input: $input) {
      cognito_sub
      file_key
      upload_url
    }
  }
`;
export const upsertAdCampaign = /* GraphQL */ `
  mutation UpsertAdCampaign(
    $input: UpsertAdCampaignInput!
    $input_delete: [UpsertAdCampaignDeleteInput]
  ) {
    upsertAdCampaign(input: $input, input_delete: $input_delete) {
      ad_campaigns {
        ad_platforms {
          created_at
          id
          name
          updated_at
        }
        budget
        cost_per_action
        cost_per_lead
        created_at
        flight_end_date
        flight_start_date
        id
        name
        spend
        updated_at
      }
      total_count
    }
  }
`;
export const upsertAgentSetting = /* GraphQL */ `
  mutation UpsertAgentSetting(
    $input: UpsertAgentSettingInput!
    $input_delete: [UpsertAgentSettingDeleteInput]
  ) {
    upsertAgentSetting(input: $input, input_delete: $input_delete) {
      agent_settings {
        agent_executable
        agent_modality
        agent_name
        ai_platform
        created_at
        id
        priority
        supports_agent_prompt
        supports_text_intro
        updated_at
      }
      total_count
    }
  }
`;
export const upsertAIFeedback = /* GraphQL */ `
  mutation UpsertAIFeedback(
    $input: UpsertAIFeedbackInput!
    $input_delete: [UpsertAIFeedbackDeleteInput]
  ) {
    upsertAIFeedback(input: $input, input_delete: $input_delete) {
      ai_feedbacks {
        cognito_sub
        created_at
        feedback_text
        id
        question
        rating
        request_id
        response
        updated_at
      }
      total_count
    }
  }
`;
export const upsertAIPlatform = /* GraphQL */ `
  mutation UpsertAIPlatform(
    $input: UpsertAIPlatformInput!
    $input_delete: [UpsertAIPlatformDeleteInput]
  ) {
    upsertAIPlatform(input: $input, input_delete: $input_delete) {
      ai_platforms {
        ai_platform
        created_at
        status
        updated_at
      }
      total_count
    }
  }
`;
export const upsertBulkSubjects = /* GraphQL */ `
  mutation UpsertBulkSubjects($input: UpsertBulkSubjectsInput!) {
    upsertBulkSubjects(input: $input) {
      total_count
    }
  }
`;
export const upsertCompletionResponse = /* GraphQL */ `
  mutation UpsertCompletionResponse(
    $input: UpsertCompletionResponseInput!
    $request_id: String!
  ) {
    upsertCompletionResponse(input: $input, request_id: $request_id) {
      response
      request_id
    }
  }
`;
export const upsertContactTranscription = /* GraphQL */ `
  mutation UpsertContactTranscription(
    $contactId: String!
    $input: ContactTranscriptionInput
  ) {
    upsertContactTranscription(contactId: $contactId, input: $input) {
      contactId
      createdAt
      transcriptions {
        channelId
        endTime
        startTime
        transcript
      }
      updatedAt
    }
  }
`;
export const upsertDeal = /* GraphQL */ `
  mutation UpsertDeal(
    $input: UpsertDealInput!
    $input_delete: [UpsertDealDeleteInput]
  ) {
    upsertDeal(input: $input, input_delete: $input_delete) {
      deals {
        created_at
        deal_description
        deal_name
        id
        subject_count
        updated_at
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const upsertProtocol = /* GraphQL */ `
  mutation UpsertProtocol(
    $input: UpsertProtocolInput!
    $input_delete: [UpsertProtocolDeleteInput]
  ) {
    upsertProtocol(input: $input, input_delete: $input_delete) {
      protocols {
        created_at
        id
        protocol_bucket
        protocol_extract_json
        protocol_key
        protocol_name
        protocol_url
        subject_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        updated_at
      }
      rankings {
        contact_id
        id
        row_num
      }
      total_count
    }
  }
`;
export const upsertQuestionnaire = /* GraphQL */ `
  mutation UpsertQuestionnaire(
    $input: UpsertQuestionnaireInput!
    $input_delete: [UpsertQuestionnaireDeleteInput]
  ) {
    upsertQuestionnaire(input: $input, input_delete: $input_delete) {
      questionnaires {
        created_at
        description
        id
        name
        questions_json
        settings_json
        subject_count
        subject_abandoned_count
        subject_complete_count
        subject_eligible_count
        subject_ineligible_count
        updated_at
      }
      total_count
    }
  }
`;
export const upsertRecruitmentSource = /* GraphQL */ `
  mutation UpsertRecruitmentSource(
    $input: UpsertRecruitmentSourceInput!
    $input_delete: [UpsertRecruitmentSourceDeleteInput]
  ) {
    upsertRecruitmentSource(input: $input, input_delete: $input_delete) {
      rankings {
        contact_id
        id
        row_num
      }
      recruitment_sources {
        contact_address_line1
        contact_address_line2
        contact_city
        contact_country
        contact_email_address
        contact_name
        contact_phone_number
        contact_postal_code
        contact_state
        created_at
        external_id
        id
        is_deletable
        parent_id
        parent_id_source_description
        parent_id_source_name
        source_description
        source_name
        subject_count
        total_budget
        total_spend
        updated_at
      }
      total_count
    }
  }
`;
export const upsertSegment = /* GraphQL */ `
  mutation UpsertSegment(
    $input: UpsertSegmentInput!
    $input_delete: [UpsertSegmentDeleteInput]
  ) {
    upsertSegment(input: $input, input_delete: $input_delete) {
      rankings {
        contact_id
        id
        row_num
      }
      segments {
        age_max
        age_min
        allergies {
          allergen_description
          allergen_type
          cc_allergen_id
          ccid
          created_at
          description
          id
          is_default
          name
          updated_at
        }
        bmi_category
        bmi_max
        bmi_min
        conditions {
          category_description
          category_name
          cc_category_id
          ccid
          created_at
          description
          icd9_code
          id
          is_child_bearing
          name
          updated_at
        }
        created_at
        ethnicity
        gender
        height_max_in
        height_min_in
        id
        interaction_frequency
        last_interaction_date
        location_coordinates
        location_radius_miles
        medications {
          category_name
          ccid
          created_at
          default_route_id
          default_route_id_name
          description
          id
          is_child_bearing
          name
          updated_at
        }
        name
        participation_status
        preferred_contact_method
        preferred_language
        previous_trial_participation
        race
        response_status
        smoker_status
        subject_count
        subject_filters_json
        trial_phase
        updated_at
        weight_max_lb
        weight_min_lb
      }
      total_count
    }
  }
`;
export const upsertSite = /* GraphQL */ `
  mutation UpsertSite(
    $input: UpsertSiteInput!
    $input_delete: [UpsertSiteDeleteInput]
  ) {
    upsertSite(input: $input, input_delete: $input_delete) {
      rankings {
        contact_id
        id
        row_num
      }
      sites {
        ccid
        created_at
        id
        site_address_line1
        site_address_line2
        site_city
        site_country
        site_description
        site_name
        site_postal_code
        site_state
        subject_count
        updated_at
      }
      total_count
    }
  }
`;
export const upsertStudy = /* GraphQL */ `
  mutation UpsertStudy(
    $input: UpsertStudyInput!
    $input_delete: [UpsertStudyDeleteInput]
  ) {
    upsertStudy(input: $input, input_delete: $input_delete) {
      rankings {
        contact_id
        id
        row_num
      }
      studies {
        agent_booked_appointment_text
        agent_needs_callback_text
        agent_precall_text
        ava_bot_alias_id
        ava_bot_config
        ava_bot_id
        ava_state_machine
        ccid
        contact_flow_id
        created_at
        end_date
        id
        protocol_extract_json
        site_description
        site_id
        site_name
        sponsor_id
        sponsor_name
        start_date
        status
        study_category
        study_cc_visits {
          id
          name
        }
        study_description
        study_name
        subject_count
        subject_protocol_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        text_agent_name
        updated_at
        visit_name
        voice_agent_name
      }
      total_count
    }
  }
`;
export const upsertSubject = /* GraphQL */ `
  mutation UpsertSubject(
    $captcha_token: String
    $input: UpsertSubjectInput!
    $input_delete: [UpsertSubjectDeleteInput]
    $input_integrations: UpsertSubjectIntegrationsInput
  ) {
    upsertSubject(
      captcha_token: $captcha_token
      input: $input
      input_delete: $input_delete
      input_integrations: $input_integrations
    ) {
      rankings {
        contact_id
        id
        row_num
      }
      subjects {
        active_enrollment_status
        age
        alcohol_use_frequency
        bmi
        ccid
        created_at
        crid
        current_study_id
        current_study_name
        date_of_birth
        diet_type
        ethnicity
        first_name
        full_name_first
        full_name_last
        gender
        height_cm
        height_in
        id
        is_possible_duplicate
        last_contact_outcomes
        last_contact_started_at
        last_name
        last_task_id
        last_touchpoint
        lead_created_at
        lifestyle_notes
        marital_status
        middle_name
        next_appt
        next_task_id
        next_touchpoint
        physical_activity_level
        preferred_language
        q_currently_in_clinical_trial
        q_date_of_last_dose
        q_date_of_last_visit
        q_ever_in_clinical_trial
        race
        ready_to_contact
        recruitment_source_name
        sleep_hours
        smoker_status
        sms_opt_in
        statuses
        stress_level
        subject_addresses {
          address_line1
          address_line2
          city
          country
          created_at
          id
          postal_code
          preferred
          state
          subject_id
          updated_at
        }
        subject_allergies {
          allergy_id
          allergy_id_allergen_description
          allergy_id_allergen_type
          allergy_id_cc_allergen_id
          allergy_id_ccid
          allergy_id_description
          allergy_id_is_default
          allergy_id_name
          allergy_name
          allergy_type
          created_at
          id
          notes
          reaction
          severity
          subject_id
          updated_at
        }
        subject_appointments {
          cc_appointment_id
          cc_patient_id
          cc_proposal_id
          cc_status
          cc_study_id
          created_at
          end_at
          id
          start_at
          subject_id
          updated_at
        }
        subject_contacts {
          ai_platform
          channel
          city
          contact_id
          created_at
          duration_seconds
          ended_at
          first_name
          full_name_first
          full_name_last
          last_name
          next_task_id
          next_touchpoint
          outcome
          outcomes
          phone_number
          purpose
          recording_bucket
          recording_key
          recording_url
          recruitment_id
          recruitment_source_name
          started_at
          subject_id
          summary
          transcript_bucket
          transcript_json
          transcript_key
          transcript_url
          updated_at
          wss_url
        }
        subject_deal_status {
          created_at
          deal_description
          deal_id
          deal_name
          status
          id
          subject_id
          updated_at
        }
        subject_emails {
          created_at
          email_address
          id
          preferred
          subject_id
          updated_at
        }
        subject_emergency_contacts {
          created_at
          email_address
          id
          name
          phone_number
          relationship_to_patient
          subject_id
          updated_at
        }
        subject_enrollment_status {
          ava_bot_alias_id
          ava_bot_config
          ava_bot_id
          ava_state_machine
          ccid
          contact_flow_id
          contact_name
          created_at
          enrollment_status
          id
          notes
          recruitment_id
          source_description
          source_name
          study_ava_bot_alias_id
          study_ava_bot_config
          study_ava_bot_id
          study_ava_state_machine
          study_category
          study_ccid
          study_contact_flow_id
          study_description
          study_enrollment_status_is_complete
          study_enrollment_status_priority
          study_id
          study_name
          study_visit_name
          subject_id
          updated_at
        }
        subject_family_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          created_at
          family_member
          id
          notes
          subject_id
          updated_at
        }
        subject_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          condition_status
          created_at
          diagnosed_date
          id
          notes
          resolved_date
          subject_id
          updated_at
        }
        subject_medications {
          created_at
          dosage_and_frequency
          end_date
          id
          medication_id
          medication_id_category_name
          medication_id_ccid
          medication_id_default_route_id
          medication_id_description
          medication_id_is_child_bearing
          medication_id_name
          medication_name
          notes
          prescribed_by
          reason_for_use
          route_id
          route_id_name
          start_date
          subject_id
          updated_at
        }
        subject_notes {
          created_at
          created_by
          id
          note
          subject_id
          updated_at
        }
        subject_phone_numbers {
          best_days_to_call
          best_time_to_call_end
          best_time_to_call_start
          created_at
          id
          phone_number
          phone_type
          preferred
          sms_opt_in
          subject_id
          updated_at
        }
        subject_physicians {
          address_line1
          address_line2
          city
          country
          created_at
          fax_number
          id
          last_exam_date
          name
          phone_number
          postal_code
          primary
          provider_type
          state
          subject_id
          updated_at
        }
        subject_recruitment_sources {
          created_at
          id
          notes
          recruitment_id
          source_description
          source_name
          subject_id
          updated_at
        }
        subject_statuses {
          created_at
          id
          status
          subject_id
          updated_at
        }
        subject_workflows {
          created_at
          id
          last_task_id
          last_touchpoint
          next_task_id
          next_touchpoint
          subject_id
          tasks_json
          updated_at
          workflow_id
          workflow_name
          workflow_tasks_json
        }
        title
        updated_at
        viewed_active_deal_page
        weight_kg
        weight_lb
      }
      total_count
    }
  }
`;
export const upsertSubjectAnswer = /* GraphQL */ `
  mutation UpsertSubjectAnswer(
    $input: UpsertSubjectAnswerInput!
    $input_delete: [UpsertSubjectAnswerDeleteInput]
  ) {
    upsertSubjectAnswer(input: $input, input_delete: $input_delete) {
      rankings {
        contact_id
        id
        row_num
      }
      subject_answers {
        answer
        answered_at
        created_at
        id
        original_answer
        original_question
        outcome
        outcome_description
        question
        questionnaire_id
        source
        subject_id
        updated_at
      }
      total_count
    }
  }
`;
export const upsertSubjectContact = /* GraphQL */ `
  mutation UpsertSubjectContact(
    $contact_id: String!
    $input: UpsertSubjectContactInput!
    $input_delete: [UpsertSubjectContactDeleteInput]
  ) {
    upsertSubjectContact(
      contact_id: $contact_id
      input: $input
      input_delete: $input_delete
    ) {
      ai_platform
      channel
      city
      contact_id
      created_at
      duration_seconds
      ended_at
      first_name
      full_name_first
      full_name_last
      last_name
      next_task_id
      next_touchpoint
      outcome
      outcomes
      phone_number
      purpose
      recording_bucket
      recording_key
      recording_url
      recruitment_id
      recruitment_source_name
      started_at
      subject_id
      summary
      transcript_bucket
      transcript_json
      transcript_key
      transcript_url
      updated_at
      wss_url
    }
  }
`;
export const upsertTableChangelog = /* GraphQL */ `
  mutation UpsertTableChangelog(
    $subject_id: Int
    $input: UpsertTableChangelogInput
  ) {
    upsertTableChangelog(subject_id: $subject_id, input: $input) {
      queue_task {
        alias
        channel
        created_at
        estimated_first_attempt_at
        first_name
        full_name_first
        full_name_last
        id
        last_name
        next_retry_at
        next_task_id
        next_touchpoint
        recruitment_id
        recruitment_source_name
        status
        subject_id
        task_id
        updated_at
        workflow_id
      }
      recruitment_sources {
        contact_address_line1
        contact_address_line2
        contact_city
        contact_country
        contact_email_address
        contact_name
        contact_phone_number
        contact_postal_code
        contact_state
        created_at
        external_id
        id
        is_deletable
        parent_id
        parent_id_source_description
        parent_id_source_name
        source_description
        source_name
        subject_count
        total_budget
        total_spend
        updated_at
      }
      segments {
        age_max
        age_min
        allergies {
          allergen_description
          allergen_type
          cc_allergen_id
          ccid
          created_at
          description
          id
          is_default
          name
          updated_at
        }
        bmi_category
        bmi_max
        bmi_min
        conditions {
          category_description
          category_name
          cc_category_id
          ccid
          created_at
          description
          icd9_code
          id
          is_child_bearing
          name
          updated_at
        }
        created_at
        ethnicity
        gender
        height_max_in
        height_min_in
        id
        interaction_frequency
        last_interaction_date
        location_coordinates
        location_radius_miles
        medications {
          category_name
          ccid
          created_at
          default_route_id
          default_route_id_name
          description
          id
          is_child_bearing
          name
          updated_at
        }
        name
        participation_status
        preferred_contact_method
        preferred_language
        previous_trial_participation
        race
        response_status
        smoker_status
        subject_count
        subject_filters_json
        trial_phase
        updated_at
        weight_max_lb
        weight_min_lb
      }
      sites {
        ccid
        created_at
        id
        site_address_line1
        site_address_line2
        site_city
        site_country
        site_description
        site_name
        site_postal_code
        site_state
        subject_count
        updated_at
      }
      studies {
        agent_booked_appointment_text
        agent_needs_callback_text
        agent_precall_text
        ava_bot_alias_id
        ava_bot_config
        ava_bot_id
        ava_state_machine
        ccid
        contact_flow_id
        created_at
        end_date
        id
        protocol_extract_json
        site_description
        site_id
        site_name
        sponsor_id
        sponsor_name
        start_date
        status
        study_category
        study_cc_visits {
          id
          name
        }
        study_description
        study_name
        subject_count
        subject_protocol_count
        subject_exclusion_filters_json
        subject_inclusion_filters_json
        text_agent_name
        updated_at
        visit_name
        voice_agent_name
      }
      subjects {
        active_enrollment_status
        age
        alcohol_use_frequency
        bmi
        ccid
        created_at
        crid
        current_study_id
        current_study_name
        date_of_birth
        diet_type
        ethnicity
        first_name
        full_name_first
        full_name_last
        gender
        height_cm
        height_in
        id
        is_possible_duplicate
        last_contact_outcomes
        last_contact_started_at
        last_name
        last_task_id
        last_touchpoint
        lead_created_at
        lifestyle_notes
        marital_status
        middle_name
        next_appt
        next_task_id
        next_touchpoint
        physical_activity_level
        preferred_language
        q_currently_in_clinical_trial
        q_date_of_last_dose
        q_date_of_last_visit
        q_ever_in_clinical_trial
        race
        ready_to_contact
        recruitment_source_name
        sleep_hours
        smoker_status
        sms_opt_in
        statuses
        stress_level
        subject_addresses {
          address_line1
          address_line2
          city
          country
          created_at
          id
          postal_code
          preferred
          state
          subject_id
          updated_at
        }
        subject_allergies {
          allergy_id
          allergy_id_allergen_description
          allergy_id_allergen_type
          allergy_id_cc_allergen_id
          allergy_id_ccid
          allergy_id_description
          allergy_id_is_default
          allergy_id_name
          allergy_name
          allergy_type
          created_at
          id
          notes
          reaction
          severity
          subject_id
          updated_at
        }
        subject_appointments {
          cc_appointment_id
          cc_patient_id
          cc_proposal_id
          cc_status
          cc_study_id
          created_at
          end_at
          id
          start_at
          subject_id
          updated_at
        }
        subject_contacts {
          ai_platform
          channel
          city
          contact_id
          created_at
          duration_seconds
          ended_at
          first_name
          full_name_first
          full_name_last
          last_name
          next_task_id
          next_touchpoint
          outcome
          outcomes
          phone_number
          purpose
          recording_bucket
          recording_key
          recording_url
          recruitment_id
          recruitment_source_name
          started_at
          subject_id
          summary
          transcript_bucket
          transcript_json
          transcript_key
          transcript_url
          updated_at
          wss_url
        }
        subject_deal_status {
          created_at
          deal_description
          deal_id
          deal_name
          status
          id
          subject_id
          updated_at
        }
        subject_emails {
          created_at
          email_address
          id
          preferred
          subject_id
          updated_at
        }
        subject_emergency_contacts {
          created_at
          email_address
          id
          name
          phone_number
          relationship_to_patient
          subject_id
          updated_at
        }
        subject_enrollment_status {
          ava_bot_alias_id
          ava_bot_config
          ava_bot_id
          ava_state_machine
          ccid
          contact_flow_id
          contact_name
          created_at
          enrollment_status
          id
          notes
          recruitment_id
          source_description
          source_name
          study_ava_bot_alias_id
          study_ava_bot_config
          study_ava_bot_id
          study_ava_state_machine
          study_category
          study_ccid
          study_contact_flow_id
          study_description
          study_enrollment_status_is_complete
          study_enrollment_status_priority
          study_id
          study_name
          study_visit_name
          subject_id
          updated_at
        }
        subject_family_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          created_at
          family_member
          id
          notes
          subject_id
          updated_at
        }
        subject_medical_history {
          condition_id
          condition_id_category_description
          condition_id_category_name
          condition_id_cc_category_id
          condition_id_ccid
          condition_id_description
          condition_id_icd9_code
          condition_id_is_child_bearing
          condition_id_name
          condition_name
          condition_status
          created_at
          diagnosed_date
          id
          notes
          resolved_date
          subject_id
          updated_at
        }
        subject_medications {
          created_at
          dosage_and_frequency
          end_date
          id
          medication_id
          medication_id_category_name
          medication_id_ccid
          medication_id_default_route_id
          medication_id_description
          medication_id_is_child_bearing
          medication_id_name
          medication_name
          notes
          prescribed_by
          reason_for_use
          route_id
          route_id_name
          start_date
          subject_id
          updated_at
        }
        subject_notes {
          created_at
          created_by
          id
          note
          subject_id
          updated_at
        }
        subject_phone_numbers {
          best_days_to_call
          best_time_to_call_end
          best_time_to_call_start
          created_at
          id
          phone_number
          phone_type
          preferred
          sms_opt_in
          subject_id
          updated_at
        }
        subject_physicians {
          address_line1
          address_line2
          city
          country
          created_at
          fax_number
          id
          last_exam_date
          name
          phone_number
          postal_code
          primary
          provider_type
          state
          subject_id
          updated_at
        }
        subject_recruitment_sources {
          created_at
          id
          notes
          recruitment_id
          source_description
          source_name
          subject_id
          updated_at
        }
        subject_statuses {
          created_at
          id
          status
          subject_id
          updated_at
        }
        subject_workflows {
          created_at
          id
          last_task_id
          last_touchpoint
          next_task_id
          next_touchpoint
          subject_id
          tasks_json
          updated_at
          workflow_id
          workflow_name
          workflow_tasks_json
        }
        title
        updated_at
        viewed_active_deal_page
        weight_kg
        weight_lb
      }
      subject_contacts {
        ai_platform
        channel
        city
        contact_id
        created_at
        duration_seconds
        ended_at
        first_name
        full_name_first
        full_name_last
        last_name
        next_task_id
        next_touchpoint
        outcome
        outcomes
        phone_number
        purpose
        recording_bucket
        recording_key
        recording_url
        recruitment_id
        recruitment_source_name
        started_at
        subject_id
        summary
        transcript_bucket
        transcript_json
        transcript_key
        transcript_url
        updated_at
        wss_url
      }
      table_changelog {
        cognito_sub
        created_at
        field_name
        id
        old_value
        new_value
        request_id
        subject_id
        table_id
        table_name
      }
      total_count
      workflows {
        agent_prompt
        created_at
        description
        id
        is_active
        name
        next_touchpoint_counts_json
        recruitment_id
        recruitment_parent_id
        recruitment_parent_source_name
        recruitment_source_name
        study_id
        study_name
        subject_count
        subject_filters_json
        tasks_json
        text_agent_name
        updated_at
        voice_agent_name
      }
    }
  }
`;
export const upsertWaitlist = /* GraphQL */ `
  mutation UpsertWaitlist(
    $captcha_token: String
    $input: UpsertWaitlistInput!
    $input_delete: [UpsertWaitlistDeleteInput]
  ) {
    upsertWaitlist(
      captcha_token: $captcha_token
      input: $input
      input_delete: $input_delete
    ) {
      waitlists {
        company_name
        created_at
        email_address
        first_name
        id
        last_name
        updated_at
      }
      total_count
    }
  }
`;
export const upsertWorkflow = /* GraphQL */ `
  mutation UpsertWorkflow(
    $input: UpsertWorkflowInput!
    $input_delete: [UpsertWorkflowDeleteInput]
  ) {
    upsertWorkflow(input: $input, input_delete: $input_delete) {
      rankings {
        contact_id
        id
        row_num
      }
      workflows {
        agent_prompt
        created_at
        description
        id
        is_active
        name
        next_touchpoint_counts_json
        recruitment_id
        recruitment_parent_id
        recruitment_parent_source_name
        recruitment_source_name
        study_id
        study_name
        subject_count
        subject_filters_json
        tasks_json
        text_agent_name
        updated_at
        voice_agent_name
      }
      total_count
    }
  }
`;
